import axios from 'axios';
import store from '@/store';

async function get(url) {
    return await axios.get(url, {headers: {Authorization: 'Bearer ' + store.state.token}, validateStatus: (status) => {return status < 500}}).then((res) => {
        if(res.status == 200){
            return {result: true, data: res.data}
        }
        else{
            if(!res.data && res.status == 401){
                store.commit('setToken', '');
                store.commit('setUserInfo', null);
                localStorage.removeItem('vuex');
            }
            return {result: false, errorcode: res.status, errorinfo: res.data ? res.data.info : '', errormsg: res.data ? res.data.message : '로그인 세션이 만료되었습니다.'};
        }
    }).catch((e) => {
        throw {result: false, errorcode: e.response.data.code, errormsg: e.response.data.message, errorinfo: e.response.data.info};
    });
}

async function post(url, data) {
    return await axios.post(url, data, {headers: {Authorization: 'Bearer ' + store.state.token}, validateStatus: (status) => {return status < 500}}).then((res) => {
        if(res.status == 200){
            return {result: true, data: res.data}
        }
        else{
            if(!res.data && res.status == 401){
                store.commit('setToken', '');
                store.commit('setUserInfo', null);
                localStorage.removeItem('vuex');
            }
            return {result: false, errorcode: res.status, errorinfo: res.data ? res.data.info : '', errormsg: res.data ? res.data.message : '로그인 세션이 만료되었습니다.'};
        }
    }).catch((e) => {
        throw {result: false, errorcode: e.response.data.code, errormsg: e.response.data.message, errorinfo: e.response.data.info};
    });
}

async function postSimpleString(url, data) {
    return await axios.post(url, data, {headers: {Authorization: 'Bearer ' + store.state.token, "Content-Type": "text/plain"}, validateStatus: (status) => {return status < 500}}).then((res) => {
        if(res.status == 200){
            return {result: true, data: res.data}
        }
        else{
            if(!res.data && res.status == 401){
                store.commit('setToken', '');
                store.commit('setUserInfo', null);
                localStorage.removeItem('vuex');
            }
            return {result: false, errorcode: res.status, errorinfo: res.data ? res.data.info : '', errormsg: res.data ? res.data.message : '로그인 세션이 만료되었습니다.'};
        }
    }).catch((e) => {
        throw {result: false, errorcode: e.response.data.code, errormsg: e.response.data.message, errorinfo: e.response.data.info};
    });
}

async function postFiles(url, data) {
    return await axios.post(url, data, {headers: {Authorization: 'Bearer ' + store.state.token, "Content-Type": "multipart/form-data"}, validateStatus: (status) => {return status < 500}}).then((res) => {
        if(res.status == 200){
            return {result: true, data: res.data}
        }
        else{
            if(!res.data && res.status == 401){
                store.commit('setToken', '');
                store.commit('setUserInfo', null);
                localStorage.removeItem('vuex');
            }
            return {result: false, errorcode: res.status, errorinfo: res.data ? res.data.info : '', errormsg: res.data ? res.data.message : '로그인 세션이 만료되었습니다.'};
        }
    }).catch((e) => {
        throw {result: false, errorcode: e.response.data.code, errormsg: e.response.data.message, errorinfo: e.response.data.info};
    });
}

async function put(url, data) {
    return await axios.patch(url, data, {headers: {Authorization: 'Bearer ' + store.state.token}, validateStatus: (status) => {return status < 500}}).then((res) => {
        if(res.status == 200){
            return {result: true, data: res.data}
        }
        else{
            if(!res.data && res.status == 401){
                store.commit('setToken', '');
                store.commit('setUserInfo', null);
                localStorage.removeItem('vuex');
            }
            return {result: false, errorcode: res.status, errorinfo: res.data ? res.data.info : '', errormsg: res.data ? res.data.message : '로그인 세션이 만료되었습니다.'};
        }
    }).catch((e) => {
        throw {result: false, errorcode: e.response.data.code, errormsg: e.response.data.message, errorinfo: e.response.data.info};
    });
}

async function remove(url, data) {
    return await axios.delete(url, data, {headers: {Authorization: 'Bearer ' + store.state.token}, validateStatus: (status) => {return status < 500}}).then((res) => {
        if(res.status == 200){
            return {result: true, data: res.data}
        }
        else{
            if(!res.data && res.status == 401){
                store.commit('setToken', '');
                store.commit('setUserInfo', null);
                localStorage.removeItem('vuex');
            }
            return {result: false, errorcode: res.status, errorinfo: res.data ? res.data.info : '', errormsg: res.data ? res.data.message : '로그인 세션이 만료되었습니다.'};
        }
    }).catch((e) => {
        throw {result: false, errorcode: e.response.data.code, errormsg: e.response.data.message, errorinfo: e.response.data.info};
    });
}

export default {get, post, put, remove, postSimpleString, postFiles};